import { StarSolid, ChatBubbleEmpty, ShareIos } from "iconoir-react";

interface PostActionsHelpProps {
  onComment: () => void;
  onShare: () => void;
}

export function PostActionsHelp({ onComment, onShare }: PostActionsHelpProps) {
  return (
    <div className="flex flex-row items-center px-4 py-2.5 w-full">
      <button
        className="flex items-center justify-center gap-2 bg-[#E06448] text-[#F4E7DA] min-w-[162px] h-10 px-4 py-2 rounded-full font-medium font-sora text-sm"
        style={{ width: "fit-content" }}
        onClick={(e) => e.stopPropagation()}
      >
        <StarSolid className="w-5 h-5 text-[#F4E7DA]" />
        <span>Sẵn sàng giúp</span>
      </button>
      <button
        onClick={onComment}
        className="flex items-center justify-center w-10 h-10 ml-8"
      >
        <ChatBubbleEmpty className="w-5 h-5 text-[#1E3A3A]" />
      </button>
      <button
        onClick={onShare}
        className="flex items-center justify-center w-10 h-10 ml-auto"
      >
        <ShareIos className="w-6 h-6 text-[#1E3A3A]" />
      </button>
    </div>
  );
}
